module.exports = __webpack_public_path__ + "img/xcx-case05.a095ccf6.png";